// eslint-disable-next-line @typescript-eslint/no-unused-vars
import Amplify, { API, Auth } from 'aws-amplify';

Amplify.configure({
    API: {
        endpoints: [
            {
                endpoint: process.env.REACT_APP_API_URL,
                name: 'OamApiPublic',
                region: 'us-east-1',
            },
            {
                endpoint: process.env.REACT_APP_API_URL,
                name: 'OamApiPrivate',
                region: 'us-east-1',
            },
        ],
    },
    Auth: {
        authenticationFlowType: 'CUSTOM_AUTH',
        region: 'us-east-1',
        userPoolId: process.env.REACT_APP_COGNITO_POOL_ID,
        userPoolWebClientId: process.env.REACT_APP_COGNITO_CLIENT_ID,
    },
});
